module.exports = __webpack_public_path__ + "assets/img/img325.57604b7d.png";